<template>
	<div :style="previewStyle" class="playbook-preview">
		<playbooks-card-buttons :template="template" />
	</div>
</template>

<script>
export default {
	props: {
		template: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		/**
		 * Get the background preview image path for the current playbook.
		 *
		 * @returns {string}  The image path
		 */
		previewBackground() {
			return this.template.screenshot_url || '';
		},
		/**
		 * Generate the background image CSS property.
		 *
		 * @returns {string} The CSS property value.
		 */
		previewStyle() {
			return this.previewBackground ? `background-image: url('${this.previewBackground}')` : '';
		},
	},
};
</script>
